import React, { FC } from "react";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../../../../../models";
import { Alert } from "../../../../components";
import { emptyCart } from "../../../state/actions/cartActions";
import { hasReSwitchHandset as hasReSwitchHandsetSelector } from "../../../state/selectors/cartSelectors";
import * as RESWITCH_SELECTORS from "../../../state/selectors/reSwitchSelectors";
import CONSTS from "../../../text-consts";
import "./ReSwitchAlert.less";

interface ReSwitchAlertProps {
    existingPhoneName: string;
    existingPhoneNumber: string;
    hasReSwitchHandset: boolean;
}

const ReSwitchAlert: FC<ReSwitchAlertProps> = ({ existingPhoneName, existingPhoneNumber, hasReSwitchHandset }) => {
    const dispatch = useDispatch();
    if (existingPhoneName && existingPhoneNumber && !hasReSwitchHandset) {
        return (
            <Alert
                closeButtonText={CONSTS.COMMON.CANCEL}
                onClose={(): Promise<void> =>
                    dispatch(emptyCart()).then(() => {
                        window.location.reload();
                    })
                }
                kind="positive"
                type="tile"
                className="reswitch-alert"
            >
                <p data-di-mask>{CONSTS.RESWITCH.CHOOSE_PHONE_MESSAGE(existingPhoneName, existingPhoneNumber)}</p>
            </Alert>
        );
    } else {
        return null;
    }
};

export default connect((state: RootState) => ({
    existingPhoneName: RESWITCH_SELECTORS.getReSwitchExistingPhoneName(state),
    existingPhoneNumber: RESWITCH_SELECTORS.getReSwitchExistingPhoneNumber(state),
    hasReSwitchHandset: hasReSwitchHandsetSelector(state),
}))(ReSwitchAlert);
